<template>
  <div class="vuestic-page-not-found-large-text">
    <div class="vuestic-page-not-found-large-text__content">
      <div class="vuestic-page-not-found-large-text__wallpaper">
        <h1 class="vuestic-page-not-found-large-text__number">:(</h1>
      </div>
      <div class="vuestic-page-not-found-large-text__wallpaper">
        <h3 class="vuestic-page-not-found-large-text__text">{{$t('error.page500.title')}}</h3>
      </div>
      <div class="vuestic-page-not-found-large-text__wallpaper flex md12">
        <div class="va-row vuestic-page-not-found-large-text__message justify--center">
          <h4 class="vuestic-page-not-found-large-text__text-small">
            {{$t('error.page500.description')}} &nbsp;
          </h4>
          <!--a href="mailto:hello@epicmax.co">hello@epicmax.co</a-->
        </div>
      </div>
      <div
        class="vuestic-page-not-found-large-text__wallpaper-button flex md12">
        <router-link :to="{ path: '/' }">
          <button class="btn btn-primary">
            {{$t('error.page500.backButton')}}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from '@/services/LoginService'
export default {
  name: 'vuestic-connection-error-large-text',
  beforeCreate () {
    this.checker = setInterval(function () {
      // TODO: Verificar uma forma melhor de fazer isso, usando algo que demonstre apenas
      LoginService.saude()
        .then(
          response => {
            clearInterval(this.checker)
            window.history.back()
          },
          error => {
            return error
          }
        )
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.checker)
  },
}
</script>

<style lang="scss">
.vuestic-page-not-found-large-text {
  min-height: 100vh;
  padding-bottom: 84px;
  background-color: $top-nav-bg;

  &__number {
    font-size: 350px;
    text-align: center;
    line-height: 1.4;
    letter-spacing: 15px;
    margin-right: -15px;
    margin-bottom: 0;
    color: white;
  }
  &__text {
    color: white;
  }
  &__text-small {
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    color: white;
    font-weight: normal;
  }
  &__wallpaper {
    background-color: $top-nav-bg;
    overflow: hidden;
    display: flex;
    text-align: center;
    align-items: flex-start;
    justify-content: center;

    a {
      margin-top: 2rem;
    }
  }
  &__wallpaper-button {
    padding-top: 20px;
    padding-bottom: 10px;
    text-align: center;
    background-color: $top-nav-bg;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  &__i-vuestic {
    z-index: 2;
    margin-top: 8%;
    height: 2.625rem;
    width: 100%;
  }
  @include media-breakpoint-down(xs) {
    .vuestic-page-not-found-large-text {
      height: $auth-mobile-main-h;

      &__wallpaper-button {
        width: 100%;
        margin-left: 0;

        .back-button {
          max-width: 300px;
          padding-left: 30px;
          padding-right: 30px;
        }
      }
      &__number {
        font-size: 150px;
      }
      &__i-vuestic {
        margin-top: 5%;
      }
      &__text-small {
        font-size: 15px;
      }
    }
  }
}
</style>
